var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDownloadIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2 8.499v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-1M3.5 5.499l2.5 2.5 2.5-2.5M6 1.999v6"
}))));
export { SvgDownloadIcon as ReactComponent };
export default __webpack_public_path__ + "26ccdea9ad0270b28f023ba5a981f9f4.svg";